import Header from "../common/Header";
import PageContainer from "../common/PageContainer";
import Tab from "../common/Tab/Tab";
import UserList from "./UserList";
import TabPage from "../common/Tab/TabPage";
import SearchBar from "../common/SearchBar";
import NewUserPopUp from "./NewUserPopUp";
import NewItemButton from "../common/NewItemButton";
import TopLine from "../common/TopLine";
import { useDisclosure } from "@chakra-ui/react";

import uniqid from "uniqid";
import { useState, useEffect } from "react";
import { fetchWithToken } from "../../functions/fetch";
import RouteProtection from "../common/RouteProtection";
import { addSearchedField, sortByMemberNumber } from "../../functions/user";

const UserPage = () => {
  const [users, setUsers] = useState([]);
  const [renters, setRenters] = useState([]);
  const [nonRenters, setNonRenters] = useState([]);
  const [tabIndex, setTabIndex] = useState(0);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [refetchUser, setRefetchUser] = useState(true);

  const [unfilteredUsers, setUnfilteredUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);

  const texts = ["全部會員", "住戶", "非住戶"];
  const pages = [
    <UserList
      users={filteredUsers}
      setUsers={setUsers}
      key={uniqid()}
      setRefetchUser={setRefetchUser}
    />,
    <UserList
      users={filteredUsers}
      setUsers={setUsers}
      key={uniqid()}
      setRefetchUser={setRefetchUser}
    />,
    <UserList
      users={filteredUsers}
      setUsers={setUsers}
      key={uniqid()}
      setRefetchUser={setRefetchUser}
    />,
  ];

  // fetch all users at beginning
  useEffect(() => {
    if (!refetchUser) return;
    fetchWithToken(
      "GET",
      `${process.env.REACT_APP_BACKEND_HOST}/api/user`,
    ).then((res) => {
      if (res.status === 200) {
        // every user has a searchedField to be searched in search bar
        const { users } = res;
        addSearchedField(users);

        sortByMemberNumber(users);

        setUsers(users);
        setUnfilteredUsers(users);
        setFilteredUsers(users);
      } else {
        console.error(res);
      }

      setRefetchUser(false);
    });
  }, [refetchUser]);

  // update renters/non-renters when users is changed with useEffect
  useEffect(() => {
    const filteredRenters = users.filter((user) => user.isRenter);
    setRenters(filteredRenters);

    const filteredNonRenters = users.filter((user) => !user.isRenter);
    setNonRenters(filteredNonRenters);
  }, [users]);

  // update what to filter after users are fetched/ switched tab
  useEffect(() => {
    const options = [users, renters, nonRenters];
    setUnfilteredUsers(options[tabIndex]);
  }, [users, tabIndex]);

  return (
    <>
      <Header />
      <RouteProtection />
      <PageContainer>
        <div className="flex justify-between items-center">
          <Tab texts={texts} tabIndex={tabIndex} setTabIndex={setTabIndex} />
          <SearchBar items={unfilteredUsers} setFunction={setFilteredUsers} />
        </div>
        <div>
          <TopLine />
          <NewUserPopUp
            isOpen={isOpen}
            onClose={onClose}
            setRefetchUser={setRefetchUser}
          />
          <div className="mt-6">
            {<NewItemButton itemName="會員" setShowPopUp={onOpen} />}
            <TabPage pages={pages} tabIndex={tabIndex} />
          </div>
        </div>
      </PageContainer>
    </>
  );
};

export default UserPage;
